/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Flickity from "flickity";
import lottie from "lottie-web";
import VanillaTilt from "vanilla-tilt";
import { DotLottie } from "@lottiefiles/dotlottie-web";

gsap.registerPlugin(ScrollToPlugin);

const HTML = document.querySelector("html");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    /** TOGGLE MENU */
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles.length > 0) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
        });
      });
    }

    /** SOUS-MENUS */
    const submenuTriggers = document.querySelectorAll(
      ".menu-item-has-children > a"
    );
    if (submenuTriggers.length > 0) {
      submenuTriggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          e.preventDefault();

          const parent = trigger.closest(".menu-item-has-children");
          const submenu = parent.querySelector(".sub-menu");

          parent.classList.toggle("open-submenu");

          // Clsose other submenus
          const otherSubmenus = document.querySelectorAll(
            ".menu-item-has-children.open-submenu"
          );
          otherSubmenus.forEach((other) => {
            if (other !== parent) {
              other.classList.remove("open-submenu");
              const otherSubmenu = other.querySelector(".sub-menu");
              if (otherSubmenu) {
                gsap.to(otherSubmenu, {
                  height: 0,
                  autoAlpha: 0,
                  duration: 0.3,
                  ease: "power2.inOut",
                });
              }
            }
          });

          if (submenu) {
            gsap.to(submenu, {
              height: parent.classList.contains("open-submenu")
                ? submenu.scrollHeight
                : 0,
              autoAlpha: parent.classList.contains("open-submenu") ? 1 : 0,
              duration: 0.3,
              ease: "power2.inOut",
            });
          }
        });
      });
    }

    /** URL select */
    const selects = document.querySelectorAll(".url-select");
    if (selects) {
      selects.forEach((select) => {
        select.addEventListener("change", () => {
          window.location.href = select.value;
        });
      });
    }

    /** HEARTH */
    const hearths = document.querySelectorAll(".icon--hearths-red");
    if (hearths) {
      hearths.forEach((h) => {
        const innerHearths = h.querySelectorAll(".hearth");
        const tl = gsap.timeline({
          paused: true,
          repeat: -1,
          repeatDelay: 0.3,
          onComplete() {
            console.log("coucou");
          },
        });

        if (innerHearths) {
          Array.from(innerHearths)
            .reverse()
            .forEach((iH, i) => {
              tl.fromTo(
                iH,
                {
                  autoAlpha: 0,
                  scale: 0.7,
                  transformOrigin: "50% 50%",
                },
                {
                  autoAlpha: 1,
                  scale: 1,
                  duration: 0.3,
                },
                "-=0.15"
              );
            });

          tl.to(h, { autoAlpha: 1 }, "+=0.5");

          Array.from(innerHearths)
            .reverse()
            .forEach((iH, i) => {
              tl.to(
                iH,
                {
                  autoAlpha: 0,
                  scale: 1.1,
                  duration: 0.2,
                },
                "-=0.1"
              );
            });

          h.addEventListener("inview", () => {
            setTimeout(() => {
              tl.play();
            }, 100);
          });
        }
      });
    }
    
    /*** HASH CLICK */
    document.querySelectorAll('a[href*="#"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        const url = new URL(link.href);

        // Vérifie que le lien pointe vers la page actuelle
        if (url.pathname !== window.location.pathname) return;
        if (url.origin !== window.location.origin) return;

        const target = document.querySelector(url.hash);

        // Vérifie que l'élément existe
        if (!target) return;

        e.preventDefault();

        gsap.to(window, {
          duration: 0.7,
          scrollTo: {
              y: target,
              offsetY: 100 // Décalage éventuel (header fixe)
          },
          ease: "expo.out"
        });
      });
    });

		var btnCookie = document.querySelector('.btn-cookies-axeptio a');
		if( btnCookie ) {
			btnCookie.addEventListener('click', e => {
				e.preventDefault();
				openAxeptioCookies()
			})
		}

    this.cursor();
    this.listHover();
    this.marquee();
    this.carousel();
    this.randomizeFocus();
    this.sliderCoverflow();
    this.coverVideo();
    this.slider();
    this.timeline();
    this.accordion();
    this.accordionArtists();
    this.bodymovin();
    this.tilt();
    this.inViewport();
  }

  tilt() {
    const elts = document.querySelectorAll(".js-tilt");

    if (elts) {
      elts.forEach((el) => {
        VanillaTilt.init(el, {
          max: 14,
          speed: 200,
          "mouse-event-element": el.dataset.tiltTrigger
            ? el.dataset.tiltTrigger
            : null,
        });
      });
    }
  }

  cursor() {
    const cursor = document.querySelector(".cursor-explosion");

    if (cursor) {
      const l = new DotLottie({
        canvas: cursor,
        loop: false,
        autoplay: false,
        src: `/wp-content/themes/nc/static/bodymovin/explosion.json`,
      });

      window.addEventListener("mousemove", (e) => {
        gsap.set(cursor, {
          top: e.clientY,
          left: e.clientX,
        });
      });

      window.addEventListener("click", (e) => {
        gsap.set(cursor, {
          top: e.clientY,
          left: e.clientX,
        });
        l.setSpeed(2);
        l.play();
      });
    }
  }

  slider() {
    const elts = document.querySelectorAll(".slider");
    if (elts) {
      elts.forEach((el) => {
        new Flickity(el, {
          pageDots: false,
          wrapAround: true,
        });
      });
    }
  }

  timeline() {
    const elts = document.querySelectorAll(".carousel-timeline");
    if (elts) {
      elts.forEach((el) => {
        const carousel = el.querySelector(".carousel-inner");
        const years = el.querySelector(".years");

        if (carousel) {
          const flkty = new Flickity(carousel, {
            pageDots: false,
            prevNextButtons: false,
            contain: true,
            draggable: false,
            on: {
              select: (index) => {
                if (years) {
                  const flktyYears = Flickity.data(years);

                  // if (flktyYears) flktyYears.select(index);
                }
              },
            },
          });

          if (years) {
            const triggers = years.querySelectorAll("a");
            const flktyYears = new Flickity(years, {
              pageDots: false,
              prevNextButtons: false,
              cellAlign: "left",
              on: {
                dragStart: () => {
                  if (triggers) gsap.set(triggers, { pointerEvents: "none" });
                },
                dragEnd: () => {
                  if (triggers) gsap.set(triggers, { pointerEvents: "auto" });
                },
                select: (index) => {
                  flkty.select(index);
                },
              },
            });
            if (triggers) {
              triggers.forEach((trigger, i) => {
                trigger.addEventListener("click", (e) => {
                  e.preventDefault();
                  flktyYears.select(i);
                });
              });
            }
          }
        }
      });
    }
  }

  bodymovin() {
    const tags = document.querySelectorAll("[data-bodymovin]");

    if (tags) {
      tags.forEach((tag) => {
        tag.addEventListener("inview", () => {
          if (!tag.classList.contains("loaded")) {
            const anim = tag.dataset.bodymovin;
            // const path = `${WPTEMPLATE}/static/bodymovin/${anim}/data.json`;
            fetch(anim).then((response) => {
              if (response.status == 200) {
                const l = new DotLottie({
                  canvas: tag,
                  loop: true,
                  autoplay: !(
                    tag.dataset.bodymovinAutoplay &&
                    tag.dataset.bodymovinAutoplay != "0"
                  ),
                  src: anim,
                });
                l.addEventListener("load", () => {
                  tag.classList.add("loaded");
                });
                tag.lottie = l;

                if (
                  tag.dataset.bodymovinAutoplay &&
                  tag.dataset.bodymovinAutoplay != ""
                ) {
                  setTimeout(() => {
                    l.play();
                    tag.classList.add("loaded");
                  }, Number.parseFloat(tag.dataset.bodymovinAutoplay) * 1000);
                } else {
                }
              }
            });
          } else if (tag.lottie) {
            tag.lottie.play();
          }
        });

        tag.addEventListener("outview", () => {
          if (tag.lottie) {
            // tag.lottie.pause();
          }
        });
      });
    }
  }

  bodymovin2() {
    const tags = document.querySelectorAll("[data-bodymovin]");

    if (tags) {
      tags.forEach((tag) => {
        tag.addEventListener("inview", () => {
          if (!tag.classList.contains("loaded")) {
            const anim = tag.dataset.bodymovin;
            // const path = `${WPTEMPLATE}/static/bodymovin/${anim}/data.json`;
            fetch(anim).then((response) => {
              if (response.status == 200) {
                const l = lottie.loadAnimation({
                  container: tag,
                  renderer: "svg",
                  loop: true,
                  autoplay: !(
                    tag.dataset.bodymovinAutoplay &&
                    tag.dataset.bodymovinAutoplay != "0"
                  ),
                  path: anim,
                });
                l.addEventListener("loaded_images", () => {
                  tag.classList.add("loaded");
                });
                tag.lottie = l;

                if (
                  tag.dataset.bodymovinAutoplay &&
                  tag.dataset.bodymovinAutoplay != ""
                ) {
                  setTimeout(() => {
                    l.play();
                    tag.classList.add("loaded");
                  }, Number.parseFloat(tag.dataset.bodymovinAutoplay) * 1000);
                } else {
                }
              }
            });
          } else if (tag.lottie) {
            tag.lottie.play();
          }
        });

        tag.addEventListener("outview", () => {
          if (tag.lottie) {
            // tag.lottie.pause();
          }
        });
      });
    }
  }

  carousel() {
    const elts = document.querySelectorAll(".carousel");

    if (elts) {
      elts.forEach((el) => {
        const flkty = new Flickity(el, {
          pageDots: false,
          contain: true,
          groupCells: true,
          cellAlign: "left",
        });
      });
    }
  }

  listHover() {
    const elts = document.querySelectorAll(".list-hover");
    if (elts) {
      elts.forEach((el) => {
        const imgs = el.querySelectorAll(".hover-imgs .img");
        const triggers = el.querySelectorAll(".trigger");

        if (imgs && triggers) {
          triggers.forEach((trigger, i) => {
            trigger.addEventListener("mouseenter", () => {
              if (imgs[i]) {
                gsap.fromTo(
                  imgs[i],
                  {
                    zIndex: 1,
                    scale: 1.05,
                    autoAlpha: 0,
                  },
                  {
                    autoAlpha: 1,
                    scale: 1,
                    duration: 0.3,
                    ease: "circ.out",
                  }
                );
              }
            });

            trigger.addEventListener("mouseleave", () => {
              if (imgs[i]) {
                gsap.to(imgs[i], {
                  zIndex: 0,
                  scale: 0.9,
                  autoAlpha: 0,
                  duration: 0.3,
                  ease: "circ.in",
                });
              }
            });
          });
        }
      });
    }
  }

  coverVideo() {
    const elts = document.querySelectorAll(".cover-video");

    if (elts) {
      elts.forEach((el) => {
        const video = el.querySelector(".video");

        if (video) {
          const tl = gsap.timeline({
            paused: true,
          });

          const logo = el.querySelector(".logo");
          const footer = el.querySelector("footer");

          tl.to(
            video,
            {
              clipPath: "polygon(50% 12%, 95% 48%, 50% 88%, 5% 48%)",
              duration: 1,
              ease: "expo.out",
            },
            "start+=0.85"
          )
            .to(
              logo,
              {
                top: "50%",
                y: "-50%",
                scale: "1.3",
                duration: 2,
                ease: "expo.inOut",
              },
              "start"
            )
            .to(
              video,
              {
                // clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
                height: `${2.2 * 100}vh`,
                duration: 1.2,
                ease: "circ.inOut",
              },
              "start+=1.45"
            )
            .to(
              video.querySelector("video"),
              {
                // clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
                scale: 0.46,
                duration: 1.2,
                ease: "circ.inOut",
              },
              "start+=1.45"
            )
            .to(
              footer,
              {
                y: "0%",
                duration: 0.3,
                ease: "circ.inOut",
              },
              "-=0.5"
            );

          setTimeout(() => {
            tl.play();
          }, 1100);
        }
      });
    }
  }

  randomizeFocus() {
    const elts = document.querySelectorAll(".randomize-focus");

    if (window.innerWidth < 992) return;

    if (elts) {
      elts.forEach((el) => {
        const cards = el.querySelectorAll(".card");
        const coords = [
          {
            rotation: -4,
          },
          {
            rotation: 0,
          },
          {
            rotation: -4,
          },
          {
            rotation: 4,
          },
        ];

        const containerW = el.clientWidth;
        const cardsLength = cards.length;
        let currentPortion = 0;
        const cardContent = el.querySelectorAll(".card .card-content");

        // el.addEventListener('in-view', () => {
        //   cards.forEach((card,i) => {
        //     gsap.fromTo(card,
        //       {
        //         scale: 1.2,
        //         autoAlpha: 0
        //       },
        //       {
        //         xPercent: coords[i%4].xPercent,
        //         yPercent: coords[i%4].yPercent,
        //         rotation : coords[i%4].rotation,
        //         autoAlpha: 1
        //       }
        //     );
        //       // gsap.set(card, {
        //       //     xPercent: (Math.random() - 0.5) * 20,
        //       //     yPercent: (Math.random() - 0.5) * 15,
        //       //     rotation: (Math.random() - 0.5) * 10,
        //       // })
        //   })
        // })

        cards.forEach((card, i) => {
          gsap.set(card, coords[i % 4]);
        });

        function resetPortion(index) {
          const opts = {
            xPercent: (Math.random() - 0.5) * 5,
            yPercent: (Math.random() - 0.5) * 5,
            rotation: (Math.random() - 0.5) * 6,
            scale: 1,
            duration: 0.8,
            ease: "elastic.out(1, 0.75)",
          };
          // Last active card
          gsap.to(cards[index], opts);
        }

        function newPortion(i) {
          gsap.to(cards[i], {
            // Reset transformation attributes
            xPercent: 0,
            yPercent: 0,
            rotation: 0,
            duration: 0.8,
            scale: 1.05,
            ease: "elastic.out(1, 0.75)", // Elastic movement at the end (out)
          });

          // For each card's child element
          cardContent.forEach((cardContent, index) => {
            // If it's not the active card
            if (index !== i) {
              gsap.to(cardContent, {
                // When index - i < 0, push left
                // When index - i > 0, push right
                // The further (index - i) moves from 0 in both ways,
                // the smaller the displacement
                xPercent: 18 / (index - i),
                ease: "elastic.out(1, 0.75)",
                duration: 0.8,
              });
              // If it is the active card
            } else {
              // Center its child
              gsap.to(cardContent, {
                xPercent: 0,
                ease: "elastic.out(1, 0.75)",
                duration: 0.8,
              });
            }
          });
        }

        el.addEventListener("mousemove", (e) => {
          // Cursor position relative to the left edge of the container
          const mouseX = e.clientX - el.getBoundingClientRect().left;

          // Cursor’s horizontal percentage within the container
          const percentage = mouseX / containerW;

          // Round the value up to get a valid index
          const activePortion = Math.ceil(percentage * cardsLength);

          // If a new portion is hovered
          if (
            currentPortion !== activePortion &&
            activePortion > 0 &&
            activePortion <= cardsLength
          ) {
            // If a portion was already hovered, reset it
            // -1 to target the correct index in the card set
            if (currentPortion !== 0) {
              resetPortion(currentPortion - 1);
            }

            // Update the index of the new portion
            currentPortion = activePortion;
            // -1 to target the correct index in the card set
            newPortion(currentPortion - 1);
          }
        });

        el.addEventListener("mouseleave", () => {
          // -1 to target the correct index in the card set
          resetPortion(currentPortion - 1);

          // No portion is hovered anymore
          currentPortion = 0;
          // Recenter all direct child elements of the cards
          gsap.to(cardContent, {
            xPercent: 0,
            ease: "elastic.out(1, 0.75)",
            duration: 0.8,
          });
        });
      });
    }
  }

  marquee() {
    const _ = this;
    const elts = document.querySelectorAll(".marquee .line");
    if (elts) {
      elts.forEach((track) => {
        track.innerHTML += track.innerHTML;

        let direction = track.dataset.dir ? track.dataset.dir : -1; // 1 = vers la gauche, -1 = vers la droite
        const speed = 40; // pixels par seconde
        let x = 0; // position actuelle
        let wrapWidth; // largeur d’un bloc A
        let lastScrollY = window.scrollY;

        function computeWrapWidth() {
          _.lazyload.update();
          // On divise par 2 car on a mis A + A
          wrapWidth = track.scrollWidth / 2;
        }

        // 2) Calcul initial + recalcul au resize
        window.addEventListener("load", computeWrapWidth);
        window.addEventListener("resize", computeWrapWidth);

        // 3) Détection du sens de scroll
        window.addEventListener(
          "scroll",
          () => {
            if (
              track.dataset.changeDir == undefined ||
              (track.dataset.changeDir && track.dataset.changeDir == "false")
            )
              return;

            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY) {
              // Scroll vers le bas → texte va vers la gauche
              direction = Number(track.dataset.dir);
            } else if (currentScrollY < lastScrollY) {
              // Scroll vers le haut → texte va vers la droite
              direction = -1 * track.dataset.dir;
            }

            lastScrollY = currentScrollY;
          },
          { passive: true }
        );

        // 4) Animation avec GSAP.ticker (boucle infinie)
        let lastTime = performance.now();

        gsap.ticker.add(() => {
          const now = performance.now();
          const dt = (now - lastTime) / 1000; // secondes écoulées
          lastTime = now;

          if (!wrapWidth) return; // au cas où le layout n’est pas encore prêt

          // Mise à jour de la position en fonction du temps, de la vitesse et du sens
          x += direction * speed * dt;

          // 5) Normalisation dans l’intervalle [-wrapWidth, 0]
          //    pour boucler proprement dans les deux sens.
          if (x <= -wrapWidth) {
            x += wrapWidth;
          } else if (x >= 0) {
            x -= wrapWidth;
          }

          gsap.set(track, { x }); // applique transform: translateX(x)
        });
      });
    }
  }

  sliderCoverflow() {
    const elts = document.querySelectorAll(".slider-coverflow");

    if (elts) {
      elts.forEach((el) => {
        const main = el.querySelector(".slider-main");

        if (main) {
          const second = el.querySelector(".slider-secondary");
          let flktySecond = false;
          if (second) {
            flktySecond = new Flickity(second, {
              cellAlign: "center",
              lazyLoad: 40,
              prevNextButtons: false,
              draggable: false,
              pageDots: false,
              wrapAround: true,
              contains: true,
            });
          }
          const flkty = new Flickity(main, {
            cellAlign: "center",
            lazyLoad: 40,
            prevNextButtons: false,
            pageDots: false,
            sync: second,
            wrapAround: true,
            on: {
              change(index) {
                if (flktySecond) {
                  flktySecond.select(index);
                }
              },
              scroll(progress) {
                if (flktySecond) {
                  const percent = this.x / this.slideableWidth;

                  // gsap.set(flktySecond.slider, {
                  //   x:
                  //     percent * flktySecond.slideableWidth +
                  //     flktySecond.slider.offsetWidth * -0.5,
                  // });
                }
              },
            },
          });

          if (second) {
            second.addEventListener("click", (e) => {
              const bound = main.getBoundingClientRect();
              if (e.clientX < bound.left) {
                // prev
                flkty.previous();
              } else if (e.clientX > bound.right) {
                // next
                flkty.next();
              }
            });
          }
        }
      });
    }
  }

  accordionArtists() {
    const elts = document.querySelectorAll(".accordion-artists");
    if (elts) {
      elts.forEach((el) => {
        const triggers = el.querySelectorAll(".accordion-header");
        const closes = el.querySelectorAll(".accordion-close");
        const contents = el.querySelectorAll(".accordion-content");
        const items = el.querySelectorAll(".accordion-item");

        if (triggers && contents) {
          triggers.forEach((trigger, i) => {
            trigger.addEventListener("click", (e) => {
              e.preventDefault();

              if (contents[i]) {
                items[i].classList.toggle("active");

                gsap.to(contents[i], {
                  height: items[i].classList.contains("active")
                    ? contents[i].scrollHeight
                    : 0,
                  autoAlpha: items[i].classList.contains("active") ? 1 : 0,
                  delay: items[i].classList.contains("active") ? 0.1 : 0,
                  ease: "circ.inOut",
                  duration: 0.3,
                });
                gsap.to(items[i], {
                  height: items[i].classList.contains("active")
                    ? contents[i].scrollHeight
                    : trigger.scrollHeight,
                  delay: items[i].classList.contains("active") ? 0.1 : 0,
                  ease: "circ.inOut",
                  duration: 0.3,
                });

                gsap.to(trigger, {
                  autoAlpha: items[i].classList.contains("active") ? 0 : 1,
                  ease: "circ.inOut",
                  delay: items[i].classList.contains("active") ? 0 : 0.1,
                  duration: 0.3,
                });
              }
            });

            if (items[i].dataset.open != undefined) {
              gsap.to(window, {
                scrollTo: {
                  y: trigger,
                  offsetY: 130,
                },
                delay: 0.4,
                onComplete: () => {
                  trigger.dispatchEvent(new Event("click"));
                },
              });
            }
          });

          if (closes) {
            closes.forEach((close, i) => {
              close.addEventListener("click", (e) => {
                e.preventDefault();
                if (triggers[i]) triggers[i].dispatchEvent(new Event("click"));
              });
            });
          }
        }
      });
    }
  }

  accordion() {
    const elts = document.querySelectorAll(".accordion");

    if (elts) {
      elts.forEach((el) => {
        const items = el.querySelectorAll(".accordion-item");
        const headers = el.querySelectorAll(".accordion-header");
        const contents = el.querySelectorAll(".accordion-content");

        if (items && headers && contents) {
          headers.forEach((header, i) => {
            header.addEventListener("click", (e) => {
              e.preventDefault();

              if (contents[i]) {
                items[i].classList.toggle("open");

                gsap.to(contents[i], {
                  height: items[i].classList.contains("open")
                    ? contents[i].scrollHeight
                    : 0,
                  autoAlpha: items[i].classList.contains("open") ? 1 : 0,
                  duration: 0.3,
                  ease: "circ.inOut",
                });
              }
            });
          });
        }
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
